import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {ListResponse} from "../interface/response/list-response";
import {DobryAgentAuthor} from "../interface/dobry-agent-blog-article";
import {DobryAgentCategory} from "../interface/dobry-agent";
import {take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class DobryAgentCategoryService {
  public readonly dobryAgentCategoryNotCountedListSubject: ReplaySubject<ListResponse<DobryAgentCategory>> = new ReplaySubject<ListResponse<DobryAgentCategory>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public loadNotCountedList(filters: object): void {
    this.httpClient
      .get(`/rest/dobryagent/api/internal/category?disableCount=1&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<DobryAgentCategory>) => {
        this.dobryAgentCategoryNotCountedListSubject.next(result);
      });
  }

  public getDobryAgentCategoryNotCountedListSubject(): ReplaySubject<ListResponse<DobryAgentCategory>> {
    return this.dobryAgentCategoryNotCountedListSubject;
  }

  public get(uuid: string): Observable<DobryAgentCategory> {
    return this.httpClient
      .get<DobryAgentCategory>(`/rest/dobryagent/api/internal/category/${uuid}`)
      .pipe(take(1));
  }
}
